import { Helmet } from "react-helmet"

export default function Auth({ children, title = "", headerTitle = "", showBackButton = false }) {
    return (
        <>
            <Helmet>
                <title>{`${title} – ${process.env.REACT_APP_NAME}`}</title>
            </Helmet>
            <div className="flex items-center justify-center min-h-screen pb-8">
                <div className="flex flex-col w-full max-w-2xl">
                    {children}
                </div>
            </div>
        </>
    )
}